<script setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { baseUrl } from '@/helpers'
import { useLangStore } from '@/stores/app/lang'

const langStore = useLangStore()

// State -----------------------------------------
const { lang } = storeToRefs(useLangStore())
const animated = ref(false)

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
function onClickLang() {
  if (!animated.value) {
    animated.value = true
    langStore.switchLang()
  }
}

langStore.$subscribe((mutation, state) => {
  document.documentElement.setAttribute('lang', lang.value)
  console.debug('%c[LanguageSwitcher] $subscribe ->', style.debug, { ...state })
})

// Main ------------------------------------------

// -----------------------------------------------
</script>

<template>
  <transition name="fade" @after-leave="animated = false">
    <div class="language-switcher" :key="lang" :lang="lang" @click="onClickLang">
      <img :src="baseUrl(`/images/lang-${lang}.png`)" />
    </div>
  </transition>
</template>

<style scoped>
/* ------------------------ */
.language-switcher {
  position: absolute;
  cursor: pointer;
}
/* ------------------------ */
</style>
